import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Users } from "lucide-react";

export default function SplitBillModal({
  open,
  onOpenChange,
  total,
  splitParts,
  setSplitParts,
  splitType,
  setSplitType,
  onSplitBill,
  onManualSplit,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Users className="w-5 h-5 text-blue-600" />
            Dividir Conta
          </DialogTitle>
        </DialogHeader>
        <div className="py-4 space-y-4">
          <p className="text-center text-2xl font-black text-gray-700">
            Total: €{total.toFixed(2)}
          </p>

          <div className="grid grid-cols-2 gap-2">
            <Button
              variant={splitType === "equal" ? "default" : "outline"}
              className={`h-12 ${splitType === "equal" ? "bg-blue-600" : ""}`}
              onClick={() => setSplitType("equal")}
            >
              Dividir Igual
            </Button>
            <Button
              variant={splitType === "manual" ? "default" : "outline"}
              className={`h-12 ${splitType === "manual" ? "bg-blue-600" : ""}`}
              onClick={onManualSplit}
            >
              Valores Manuais
            </Button>
          </div>

          {splitType === "equal" && (
            <>
              <div className="flex items-center justify-center gap-4">
                <Button
                  variant="outline"
                  className="w-12 h-12 text-xl font-bold"
                  onClick={() => setSplitParts(Math.max(2, splitParts - 1))}
                >
                  -
                </Button>
                <div className="text-center">
                  <span className="text-4xl font-black text-blue-600">{splitParts}</span>
                  <p className="text-xs text-gray-500">pessoas</p>
                </div>
                <Button
                  variant="outline"
                  className="w-12 h-12 text-xl font-bold"
                  onClick={() => setSplitParts(splitParts + 1)}
                >
                  +
                </Button>
              </div>
              <div className="bg-blue-50 rounded-lg p-4 text-center">
                <p className="text-sm text-blue-600">Cada pessoa paga:</p>
                <p className="text-3xl font-black text-blue-600">
                  €{(total / splitParts).toFixed(2)}
                </p>
              </div>
              <Button
                className="w-full h-12 bg-blue-600 hover:bg-blue-700 font-bold"
                onClick={onSplitBill}
              >
                DIVIDIR E PAGAR
              </Button>
            </>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
